import { useState } from 'react';
import { Box, Flex, IconButton } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';
import ReactJson from 'react-json-view';
import moment from 'moment';

import { QueryTable } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';
import { Dialog, FieldView, Txt } from '@app/components/common';
import { Delivery } from '@app/api/socket-service';
import { USER_DATE_TIME_FORMAT } from '@app/utils';

import { useColumns } from './columns';
import { getDeliveryName, getDeliveryStatus } from './utils/getDeliveryName';

export const DeliveriesTable = () => {
  const api = useApi();
  const [fetchData] = useFetchData({
    method: api.socket.getDeliveries
  });

  const columns = useColumns();

  const [open, setOpen] = useState(false);
  const [delivery, setDelivery] = useState<Delivery>();

  const onOpen = async (delivery: Delivery) => {
    const response = await api.socket.getDelivery(delivery.id);

    setDelivery(response.data);
    setOpen(true);
  };

  return <>
    <QueryTable
      title="Доставки"
      columns={columns}
      fetchData={fetchData}
      onRowClick={onOpen}
    />
    <Dialog 
      title={delivery?.key}
      open={open} onClose={() => setOpen(false)}
    >
      {delivery && <Box display="flex" justifyContent="space-between">
        <Box w='100%'>
          <Box display="flex" alignItems="center" w='100%'>
            <Flex gap={4} justifyContent='space-between' flex={1}>
              <Txt color='brand.500'>{getDeliveryName(delivery.key)}</Txt>
              <Txt color='gray.500'>{getDeliveryStatus(delivery.status)}</Txt>
            </Flex>
          </Box>
          <Box display="flex" flexDirection='column' gap={0} w='100%'>
            <FieldView title="Пользователь" value={delivery?.userDevice.split('-')[0]} direction='row' fullWidth />
            <FieldView title="Устройство ID" value={delivery?.userDevice.split('-')[1]} direction='row' fullWidth />

            <FieldView title="Создано" value={moment(delivery.createdTimestamp).format(USER_DATE_TIME_FORMAT)} direction='row' fullWidth />
            <FieldView title="Получено" value={moment(delivery.receivedTimestamp / 1000).format(USER_DATE_TIME_FORMAT)} direction='row' fullWidth />
            <FieldView title="Отправлено" value={moment(delivery.sentTimestamp / 1000).format(USER_DATE_TIME_FORMAT)} direction='row' fullWidth />

            
          </Box>
          {delivery.request.String && <Box display="flex" pt={2} flexDirection="column" gap={4} w='100%'>
            <Txt color='gray.500'>Запрос</Txt>
            <Box overflow="auto" maxHeight={400} border='1px solid' borderColor='gray.200'>
              <ReactJson src={JSON.parse(delivery.request.String)} name={false} collapsed={2} />
            </Box>
          </Box>}
          {delivery.response.String && <Box display="flex" pt={2} flexDirection="column" gap={4} w='100%'>
            <Txt color='gray.500'>Ответ</Txt>
            <Box overflow="auto" maxHeight={400}>
              <ReactJson src={JSON.parse(delivery.response.String)} name={false} collapsed={2} />
            </Box>
          </Box>}
        </Box>
      </Box>}
    </Dialog>
  </>;
};